import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserMgmtComponent } from './user-mgmt.component';
import {BreadcrumbModule} from 'primeng/breadcrumb';
import {TableModule} from 'primeng/table';
import {ToastModule} from 'primeng/toast';
import {CheckboxModule} from 'primeng/checkbox';
import {MenuModule} from 'primeng/menu';
import {InputTextModule} from 'primeng/inputtext';
import {ProgressSpinnerModule} from 'primeng/progressspinner';
import {ButtonModule} from 'primeng/button';
import {RippleModule} from 'primeng/ripple';
import {PaginatorModule} from 'primeng/paginator';
import { AddEditUserFormComponent } from './add-edit-user-form/add-edit-user-form.component';
import {TabViewModule} from 'primeng/tabview';
import {DialogModule} from 'primeng/dialog';
import {ReactiveFormsModule} from '@angular/forms';
import {MultiSelectModule} from 'primeng/multiselect';
import {PasswordModule} from 'primeng/password';
import {AccordionModule} from "primeng/accordion";
import {FieldsetModule} from "primeng/fieldset";
import {DividerModule} from "primeng/divider";
import {NgxJsonViewerModule} from "ngx-json-viewer";
import {ConfirmDialogModule} from 'primeng/confirmdialog';



@NgModule({
  declarations: [UserMgmtComponent, AddEditUserFormComponent],
    imports: [
        CommonModule,
        BreadcrumbModule,
        TableModule,
        ToastModule,
        CheckboxModule,
        MenuModule,
        InputTextModule,
        ProgressSpinnerModule,
        ButtonModule,
        RippleModule,
        PaginatorModule,
        TabViewModule,
        DialogModule,
        ReactiveFormsModule,
        MultiSelectModule,
        PasswordModule,
        AccordionModule,
        FieldsetModule,
        DividerModule,
        NgxJsonViewerModule,
        ConfirmDialogModule
    ]
})
export class UserMgmtModule { }
